
import { Position, getBezierPath } from '@xyflow/react'
import React from 'react'

interface SmartBezierEdgeProps {
  sourceX: number
  sourceY: number
  targetX: number
  targetY: number
  sourcePosition?: Position
  targetPosition?: Position
  style?: React.CSSProperties
}

export const SmartBezierEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition = Position.Bottom,
  targetPosition = Position.Top,
  style = {},
}: SmartBezierEdgeProps) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature: 0.5,
  })

  return (
    <path
      style={{
        ...style,
        stroke: '#ffffff',
        strokeWidth: 2,
        fill: 'none',
        opacity: 0.5,
      }}
      className="react-flow__edge-path"
      d={edgePath}
    />
  )
}
